import { render, staticRenderFns } from "./_more.vue?vue&type=template&id=376b8052&lang=pug&"
import script from "./_more.vue?vue&type=script&lang=js&"
export * from "./_more.vue?vue&type=script&lang=js&"
import style0 from "./_more.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports